import React, { useState, useEffect, useRef, useMemo } from 'react';
import Tour from 'reactour';
import Popup from 'reactjs-popup';
import { styleParagraph, styleInputInline } from '../../helpers/data';
import { Input } from '../../styles/CommonStyles';
import { IconMdBorderColor } from '../../components/menu/styles';
import { Button, SpanButton } from '../../pages/postEdit/stylePostEdit';
import { DivTextAreaTour, TextAreaTour } from '../../pages/configPageBlog/configPageBlogStyle';

export default function CustomTour({ steps, openTour, closeTour, toggleVerifyAnyPopup }) {
    const [currentStep, setCurrentStep] = useState(JSON.parse(localStorage.getItem('steps_helper')) || {});
    const [openPopup, setOpenPopup] = useState(false);

    const ContentPopupWarning = ({ functionCloseWarning, functionToggleVerify }) => {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '16px',
                }}
            >
                <p style={{ fontSize: '20px' }}>Deseja fechar o assistente de configuração ?</p>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-evenly',
                        margin: '16px 0 0 0',
                    }}
                >
                    <Button
                        onClick={() => {
                            functionToggleVerify(false);
                            setOpenPopup(false);
                            functionCloseWarning(false);
                        }}
                    >
                        <SpanButton>Sim</SpanButton>
                    </Button>
                    <Button
                        onClick={() => {
                            setOpenPopup(false);
                        }}
                    >
                        <SpanButton>Não</SpanButton>
                    </Button>
                </div>
            </div>
        );
    };
    return (
        <>
            <Tour
                rounded="6"
                showNumber={false}
                steps={steps}
                isOpen={openTour}
                onRequestClose={() => setOpenPopup(true)}
                closeWithMask={false}
                disableKeyboardNavigation={['esc']}
                startAt={0}
                getCurrentStep={(current) => {
                    localStorage.setItem('steps_helper', JSON.stringify({ ...currentStep, steps: current }));
                }}
            />
            <Popup
                open={openPopup}
                onClose={() => setOpenPopup(false)}
                children={<ContentPopupWarning functionCloseWarning={closeTour} functionToggleVerify={toggleVerifyAnyPopup} />}
                overlayStyle={{ zIndex: 'calc(9999*9999)' }}
                contentStyle={{
                    width: 'fit-content',
                    height: 'fit-content',
                    borderRadius: '4px',
                }}
            />
        </>
    );
}

export function Child({ instruction, nameSocial, placeholder, refSocial, dataSiteSocial, setFunction }) {
    try {
        const styleInput = {
            borderBottom: '1px solid #000',
            borderRadius: '0',
            padding: ' 12px 0px 8px 8px',
            width: 'calc(100% - 35px)!important',
            maxWidth: 'unset!important',
        };
        const styleDivLocalizador = {
            position: 'absolute',
            top: '-45px',
            height: '40px',
            background: '#0594a5',
            color: '#fff',
            padding: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '6px',
            border: '1px solid #047a89',
            fontSize: '20px',
        };
        return (
            <div
                style={{
                    width: '350px',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <p
                    style={{
                        fontSize: '20px',
                        padding: '0 20px',
                        margin: '0 0 12px 0',
                    }}
                >
                    {instruction || `Aqui você irá inserir o link do seu perfil do ${nameSocial}.`}
                </p>
                <div
                    style={{
                        margin: '0 8px 0 0',
                        width: '350px',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <Input
                        ref={refSocial}
                        list="teste"
                        placeholder={placeholder || `Insira o link do seu perfil no instagram`}
                        style={styleInput}
                        value={dataSiteSocial || ''}
                        onBlur={(event) => setFunction(event)}
                        onChange={(event) => setFunction(event)}
                        maxLength="200"
                        remove={true}
                    />
                    <datalist id="teste">
                        <option value="teste1" />
                        <option value="teste2" />
                        <option value="teste3" />
                        <option value="teste4" />
                        <option value="teste5" />
                    </datalist>
                    <IconMdBorderColor />
                </div>
                <div style={styleDivLocalizador}>
                    <span>Início</span>
                </div>
            </div>
        );
    } catch (error) {
        console.log(error);
    }
}

export const InputTitle = ({ title, refMenu, dataSiteMenu, setFunction, maxLength }) => {
    try {
        const styleDivLocalizador = {
            position: 'absolute',
            top: '-45px',
            height: '40px',
            background: '#0594a5',
            color: '#fff',
            padding: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '6px',
            border: '1px solid #047a89',
            fontSize: '20px',
        };
        return (
            <div
                style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                }}
            >
                <p style={styleParagraph}>Insira o {title.toLocaleLowerCase()}</p>
                <br />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Input
                        ref={refMenu}
                        placeholder={title}
                        style={styleInputInline}
                        value={dataSiteMenu.toString()}
                        onChange={(event) => setFunction(event)}
                        onBlur={(event) => setFunction(event)}
                        maxLength={maxLength ? maxLength : '20'}
                    />
                    <IconMdBorderColor style={{ margin: '0 0 0 10px' }} />
                </div>
                <div style={styleDivLocalizador}>
                    <span>Início</span>
                </div>
            </div>
        );
    } catch (error) {
        console.log(error);
    }
};

export const TextAreaSlider = ({ title, dataSliderTextarea, refTextarea, setFunction, pageName }) => {
    try {
        const styleDivLocalizador = {
            position: 'absolute',
            top: '-45px',
            height: '40px',
            background: '#0594a5',
            color: '#fff',
            padding: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '6px',
            border: '1px solid #047a89',
            fontSize: '20px',
        };
        return (
            <DivTextAreaTour>
                <p style={styleParagraph}>
                    Insira o {title.toLocaleLowerCase()} <br /> {dataSliderTextarea.length}/250
                </p>
                <br />
                <TextAreaTour
                    maxLength="250"
                    ref={refTextarea}
                    value={dataSliderTextarea}
                    onBlur={(event) => {
                        setFunction(event);
                    }}
                    onChange={(event) => {
                        setFunction(event);
                    }}
                    placeholder={`Insira o ${title.toLocaleLowerCase()}`}
                />
                <div style={styleDivLocalizador}>
                    <span>{pageName ?? 'Início'}</span>
                </div>
            </DivTextAreaTour>
        );
    } catch (error) {
        console.log(error);
    }
};
